import { t } from 'i18next'

import type {
    PaymentMethodSale,
    ReasonProductNotDistributedSale,
    StatusDisputeSale,
    StatusSale,
    TypeDisputeSale,
} from 'app/types/transactions/sale'

/** Selection sent for the products whose selection is unknown. */
export const SELECTION_UNKNOWN = 'Z99'

/** Search params used in the sale page. */
export const searchParametersSale = {
    AMOUNT_MAX: 'amount_max',
    AMOUNT_MIN: 'amount_min',
    CARD: 'card',
    CLIENTS: 'clients',
    DATE_END: 'date_end',
    DATE_START: 'date_start',
    DISPUTE_STATUS: 'status_dispute',
    HAS_ICOUPONS: 'has_icoupons',
    KONVIVE: 'konvive',
    MANAGERS: 'managers',
    PAYMENT_METHOD: 'payment_method',
    SALE: 'sale',
    SALE_STATUS: 'sale_status',
    SITES: 'sites',
    TERMINALS: 'terminals',
}

/** Search params used in the sale API. */
export const searchParametersSaleApi = {
    AMOUNT_MAX: 'total__lte',
    AMOUNT_MIN: 'total__gte',
    CARD: 'pan__icontains',
    CLIENTS: 'terminal__site__customer_name__id__in',
    DATE_END: 'date_time__lte',
    DATE_START: 'date_time__gte',
    DISPUTE_STATUS: 'dispute_status',
    HAS_ICOUPONS: 'has_icoupons',
    KONVIVE: 'search',
    MANAGERS: 'terminal__site__customer_name__client__id__in',
    PAYMENT_METHOD: 'payment_method__in',
    SALE: 'id__icontains',
    SITES: 'terminal__site__id__in',
    STATUS: 'sale_ok',
    TERMINALS: 'terminal__id__in',
}

/** Get the payment method translated. */
export const paymentMethodSaleTranslated: () => Record<
    PaymentMethodSale,
    string
> = () => ({
    CASH: t('cash'),
    CREDIT_CARD: t('creditCard'),
    KONVIVES: 'Konvives',
    MEAL_VOUCHER: t('mealVoucher'),
    PRIVATE_CARD: t('privateCard'),
})

/** Get the status of the sale translated. */
export const statusSaleTranslated: () => Record<StatusSale, string> = () => ({
    ALL: t('all'),
    CORRECT: t('correct'),
    PROBLEM: t('problem'),
})

/** Get the type of the dispute sale translated. */
export const typeDisputeSaleTranslated: () => Record<
    TypeDisputeSale,
    string
> = () => ({
    CLOSED_LOCKER: t('closedLocker'),
    MENU_NOT_TAKEN: t('menuNotTaken'),
    NUMBER_PRODUCTS: t('numberProducts'),
    OTHER: t('other'),
    WRONG_PRICE: t('wrongPrice'),
    WRONG_PRODUCT: t('wrongProduct'),
})

/** Get the status of the dispute sale translated. */
export const statusDisputeSaleTranslated: () => Record<
    StatusDisputeSale,
    string
> = () => ({
    CONTACTED: t('contacted'),
    DISPUTED: t('disputedFeminine'),
    IN_PROGRESS: t('inProgress'),
    REFUNDED: t('refundedFeminine'),
    REFUSED: t('refusedFeminine'),
})

export const reasonProductNotDistributedSaleTranslated: () => Record<
    ReasonProductNotDistributedSale,
    string
> = () => ({
    CONFIGURATION: t('selectionNotConfigured'),
    CONNECTION: t('channelNotConnected'),
    DOOR: t('doorOpen'),
    ELEVATOR: t('elevatorFault'),
    ELIMINATED: t('dispensingCancelled'),
    EXPIRED: t('productExpired'),
    MOTOR: t('motorFailure'),
    QUEUE: t('queueFull'),
    RESET: t('communicationLost'),
    STOCK: t('productSoldOut'),
    TOKEN: t('orderNotFound'),
    UNKNOWN: t('unknownError'),
})

/** Prefix the product name with its selection, unless the selection is unknown. */
export const getProductNameWithSelection = (
    name: string,
    selection: string,
): string => (selection === SELECTION_UNKNOWN ? name : `[${selection}] ${name}`)
